import React, { useState, useEffect } from 'react';
import {
    Table,
    Button,
    Layout,
    Card,
    Tag,
    Typography,
    Dropdown,
    Menu,
    Row,
    Col,
    Tooltip,
    Popconfirm,
    Spin,
    Input,
    Select,
    Modal,
} from 'antd';
import { DownloadOutlined, EllipsisOutlined, SearchOutlined, EditOutlined, DeleteOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import apiRequest from '../../hooks/ApiRequest';
import HomeLayout from '../../components/HomeLayout';
import EndorsAmend from '../../components/EndorsAmend';
import { toast } from 'react-toastify';


// const { Content } = Layout;
const { Title } = Typography;
const { Item: MenuItem } = Menu;
const { Search } = Input;
const { Option } = Select;

const Endorsement = () => {
    const [loading, setLoading] = useState(false);
    const [baseData, setBaseData] = useState([]);
    const [filterTable, setFilterTable] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = user.role;
    const UserId = localStorage.getItem('loggedInUserID');
    const [endorsementTypes, setEndorsementTypes] = useState([]);
    const [showEndorsForm, setShowEndorsForm] = useState(false);
    const [selectedPolicyId, setSelectedPolicyId] = useState(null);
    const [selectedRecord, setSelectedRecord] = useState(null);


    useEffect(() => {
        fetchEndorsements();
        fetchEndorsementTypes();
    }, []);

    const userRole = user?.RoleName
    const userId = user?.UserId

    const getEndorsementsApi = () => {
        debugger;
        switch (userRole.toLowerCase()) {
            case "insureradmin":
                return `${process.env.REACT_APP_BASE_URL}/Policy/GetEndorsementbyInsurer/${userId}`
            case "broker":
                return `${process.env.REACT_APP_BASE_URL}/Policy/GetAllEndorsementsByBroker/${userId}`
            case "customer":
                return `${process.env.REACT_APP_BASE_URL}/Policy/GetEndorsementbyCustomer/${userId}`
            case 'underwriter':
                return `${process.env.REACT_APP_BASE_URL}/Policy/GetEndorsementbyUnderwriter/${userId}`;
            default:
                return null
        }
    }

    const fetchEndorsements = async () => {
        try {
            const apiUrl = getEndorsementsApi()
            if (!apiUrl) return

            const res = await apiRequest(apiUrl, "GET")
            const result = res.data ? res.data : res

            if (result.success) {
                setBaseData(result.data);
                setFilterTable(result.data);
            }
            else {
                toast.error(result.message || "No endorsements found")
            }
        } catch (error) {
            toast.error('Error fetching endorsement')
            console.error('Fetch endorsement error:', error)
        }

    }

    const fetchEndorsementTypes = async () => {
        try {
            const response = await apiRequest(`${process.env.REACT_APP_BASE_URL}/Policy/GetAllEndorsementType/EndorsementsType`, 'GET');
            if (response.success) {
                setEndorsementTypes(response.data.data);
            } else {
                toast.error('Failed to fetch endorsement types');
            }
        } catch (error) {
            console.error('Error fetching endorsement types:', error);
            toast.error('Error fetching endorsement types');
        }
    };


    // const fetchEndorsements = async () => {
    //     setLoading(true);
    //     try {
    //         let url = '';
    //         if (role == '311') {
    //             url = `${process.env.REACT_APP_BASE_URL}/Policy/GetEndorsementbyCustomer/${UserId}`;
    //         } else if (role == '308') {
    //             url = `${process.env.REACT_APP_BASE_URL}/Policy/GetEndorsementbyInsurer/${UserId}`;
    //         } else if (role == '303') {
    //             url = `${process.env.REACT_APP_BASE_URL}/Policy/GetEndorsementbyUnderwriter/${UserId}`;
    //         }
    //         const response = await apiRequest(url, 'GET');
    //         if (response.success) {
    //             setBaseData(response.data.data);
    //             setFilterTable(response.data.data);
    //         }
    //         // setBaseData(response.data);
    //         // setFilterTable(response.data);
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleSearch = (value) => {
        setSearchText(value);
        const lowerValue = value.toLowerCase().trim();
        const filtered = baseData.filter(o => {
            return (
                String(o.Id).includes(lowerValue) ||
                String(o.PolicyId).includes(lowerValue) ||
                String(o.CustomerId).includes(lowerValue) ||
                String(o.ApprovedBy || '').toLowerCase().includes(lowerValue))
        });
        setFilterTable(filtered);
    };

    const handleStatusFilter = (value) => {
        setStatusFilter(value);
        let filtered = baseData;

        if (value !== 'all') {
            filtered = baseData.filter(item => {
                // Find the numeric status that matches the text filter
                const statusEntry = Object.entries(statusMap).find(
                    ([_, statusData]) => statusData.text === value
                );
                const numericStatus = statusEntry ? parseInt(statusEntry[0]) : null;

                // Compare with both numeric status and text (for flexibility)
                return (
                    item.status === numericStatus ||
                    statusMap[item.status]?.text === value
                );
            });
        }

        // Apply search filter if there's search text
        if (searchText) {
            const lowerValue = searchText.toLowerCase().trim();
            filtered = filtered.filter(o => {
                return (
                    String(o.Id).includes(lowerValue) ||
                    String(o.PolicyId).includes(lowerValue) ||
                    String(o.CustomerId).includes(lowerValue) ||
                    String(o.ApprovedBy || '').toLowerCase().includes(lowerValue)
                );
            });
        }

        setFilterTable(filtered);
    };


    const statusMap = {
        0: { color: 'orange', text: 'Pending' },
        2: { color: 'green', text: 'Approved' },
        3: { color: 'gold', text: 'Closed' },
        4: { color: 'red', text: 'Rejected' },
    };

    const statusTag = (status) => {
        const statusMap = {
            0: { color: 'orange', text: 'Pending' },
            2: { color: 'green', text: 'Approved' },
            3: { color: 'gold', text: 'Closed' },
            4: { color: 'red', text: 'Rejected' },
        };

        return <Tag color={statusMap[status]?.color || 'default'}>
            {statusMap[status]?.text || status}
        </Tag>;
    };

    const handleApprove = async (id) => {
        setLoading(true);
        try {
            const record = filterTable.find(item => item.id === id);
            if (!record) {
                toast.error('Record not found');
                return;
            }
            record.status = 2; // Set status to Approved

            const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/UpdateEndorsementStatus/UpdateEndorsementStatus`, 'POST', record);

            if (response.success) {
                toast.success('Endorsement approved successfully');
                fetchEndorsements();
            }
        } catch (error) {
            console.error('Error approving endorsement:', error);
            toast.error('Error approving endorsement');
        } finally {
            setLoading(false);
        }
    };

    const handleReject = async (id) => {
        setLoading(true);
        try {
            const record = filterTable.find(item => item.id === id);
            if (!record) {
                toast.error('Record not found');
                return;
            }
            record.status = 4; // Set status to Rejected
            const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/UpdateEndorsementStatus/UpdateEndorsementStatus`, 'POST', record);
            if (response.success) {
                toast.success('Endorsement rejected successfully');
                fetchEndorsements();
            }
        } catch (error) {
            console.error('Error rejecting endorsement:', error);
            toast.error('Error rejecting endorsement');
        } finally {
            setLoading(false);
        }
    };

    const EditRecord = async (id) => {
        window.location.href = `/endorsedpolicy/${id}`;
    };

    const deleteRecord = async (id) => {
        setLoading(true);
        try {
            const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/DeleteEndorsementRequest/EndorsementRequest/${id}`, 'POST');
            if (response.success) {
                toast.success('Endorsement request deleted successfully');
                fetchEndorsements();
            } else {
                toast.error('Failed to delete endorsement request');
            }
        } catch (error) {
            console.error('Error deleting endorsement request:', error);
            toast.error('Error deleting endorsement request');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = async (id) => {
        setLoading(true);
        setLoading(true);
        try {
            const record = filterTable.find(item => item.id === id);
            if (!record) {
                toast.error('Record not found');
                return;
            }
            record.status = 3; // Set status to Closed

            const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/UpdateEndorsementStatus/UpdateEndorsementStatus`, 'POST', record);

            if (response.success) {
                toast.success('Endorsement Closed successfully');
                fetchEndorsements();
            }
        } catch (error) {
            console.error('Error closing endorsement:', error);
            toast.error('Error closing endorsement');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'Policy Number',
            dataIndex: 'policyNumber',
            key: 'policyNumber',
            render: (text, record) => (
                <a href={`/endorsedpolicy/${record.policyId}`}>
                    {text}
                </a>
            ),
        },
        {
            title: 'Change Type',
            dataIndex: 'TypeOfChangeId',
            key: 'TypeOfChangeId',
            render: (_, record) => {
                const type = endorsementTypes.find(type => type.id === record.typeOfChangeId);
                return type ? type.name : 'Unknown';
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: statusTag,
        },
        {
            title: 'Document',
            key: 'document',
            render: (_, record) => (
                <Button type="text" onClick={() => {
                    if (record.documentUrl) {
                        window.open(record.documentUrl, '_blank');
                    }
                }}>
                    <DownloadOutlined />
                </Button>
            ),
        },
        {
            title: 'Comments',
            key: 'comments',
            render: (_, record) => (
                <span>{record.data || 'No comments'}</span>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <>
                    {/* Insurer & Underwriter: Only Approve/Reject */}
                    {(userRole?.toLowerCase() === 'insureradmin' || userRole?.toLowerCase() === 'underwriter') && record.status === 0 && (
                        <>
                            <Tooltip title="Approve">
                                <Button
                                    type="primary"
                                    onClick={() => handleApprove(record.id)}>
                                    <CheckOutlined />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Reject">
                                <Button
                                    danger
                                    onClick={() => handleReject(record.id)}>
                                    <CloseOutlined />
                                </Button>
                            </Tooltip>
                        </>
                    )}

                    {/* Edit button for Customer & Broker */}
                    {/* Edit button for Customer & Broker */}
                    {/* Customer & Broker: Only Edit (if pending) and Delete */}
                    {(userRole?.toLowerCase() === 'customer' || userRole?.toLowerCase() === 'broker') && (
                        <>
                            {record.status === 0 && (
                                <Tooltip title="Edit">
                                    <Button
                                        className="edit_btn"
                                        onClick={() => {
                                            setSelectedPolicyId(record.policyId);
                                            setSelectedRecord(record);
                                            setShowEndorsForm(true);
                                        }}
                                    >
                                        <EditOutlined />
                                    </Button>
                                </Tooltip>
                            )}

                            {/* Delete always visible for Customer & Broker */}
                            <Popconfirm
                                title="Are you sure to delete this record?"
                                onConfirm={() => deleteRecord(record.id)}
                            >
                                <Tooltip title="Delete">
                                    <Button type="danger">
                                        <DeleteOutlined />
                                    </Button>
                                </Tooltip>
                            </Popconfirm>
                        </>
                    )}


                    {/* Close button (visible when approved, status = 1) */}
                    {record.status === 1 && (
                        <Popconfirm
                            title="Are you sure to close this record?"
                            onConfirm={() => handleClose(record.id)}>
                            <Tooltip title="Close">
                                <Button type="default">Close</Button>
                            </Tooltip>
                        </Popconfirm>
                    )}


                </>
            ),
        },
    ];
    return (
        <HomeLayout>
            {/* <div className="mainContnet ant-layout-content dashboard"> */}
            <div className="dash-bg-white">
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={12}>
                        <div className="section-top-heading">
                            <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                                Endorsement Requests
                            </h3>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                        <div className="item-search">
                            <Search
                                placeholder="Search requests"
                                allowClear
                                enterButton={<SearchOutlined />}
                                value={searchText}
                                onChange={(e) => handleSearch(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={6} xl={4}>
                        <div className="item-search">
                            <Select
                                value={statusFilter}
                                onChange={handleStatusFilter}
                                style={{ width: '100%' }}
                            >
                                <Option value="all">All Statuses</Option>
                                {Object.values(statusMap).map(status => (
                                    <Option key={status.text} value={status.text}>
                                        {status.text}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col>
                    {/* <Col xs={24} sm={24} md={6} lg={4} xl={2}>
                            <div className="create-quotation">
                                <Button type="primary" onClick={fetchEndorsements}>
                                    Refresh
                                </Button>
                            </div>
                        </Col> */}
                </Row>
            </div>

            {loading ? (
                <Spin
                    className="loader-icon-fixed"
                    size="large"
                    style={{ display: 'block', marginTop: 20 }}
                />
            ) : (
                <Table
                    columns={columns}
                    dataSource={filterTable}
                    rowKey="Id"
                    className="dashboard-table"
                />
            )}

            {/* ===== Add Modal here ===== */}
            <Modal
                title="Endorsement/Amendment"
                centered
                visible={showEndorsForm}
                footer={null}
                onCancel={() => setShowEndorsForm(false)}
                width={768}
            >
                {selectedRecord && (
                    <EndorsAmend
                        record={selectedRecord}
                        onClose={() => {
                            setShowEndorsForm(false);
                            // fetchEndorsements();
                        }}

                        onSuccess={(updatedRecord) => {
                            // update local state without refreshing the page
                            setBaseData(prev =>
                                prev.map(item => item.id === updatedRecord.id ? updatedRecord : item)
                            );
                            setFilterTable(prev =>
                                prev.map(item => item.id === updatedRecord.id ? updatedRecord : item)
                            );
                        }}
                    />
                )}
            </Modal>

            {/* </div> */}
        </HomeLayout>
    );
};

export default Endorsement;